import { IApplicationState } from '../../../../../../types/types';
import { getDriveDoc } from '../../../../../../store/model/driveDocs/selectors/getDriveDoc';

export const getDroppedAttachments = (state: IApplicationState) => {
    const driveDocIds = state.comments.droppedAttachmentIds || [];
    return driveDocIds.map(driveDocId => getDriveDoc(state, driveDocId));
}
